import type { TaskResult } from "../types";

export async function gradeProject10(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Proteger libro de trabajo con contraseña 12345
  try {
    await Excel.run(async (context) => {
      const protection = context.workbook.protection;
      protection.load("protected");
      await context.sync();

      results.push({ taskId: 1, passed: protection.protected === true });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Agrupar filas 7-12 en hoja "Cursos"
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Cursos");

      const row7 = ws.getRange("A7");
      const row12 = ws.getRange("A12");
      row7.load("rowHidden");
      row12.load("rowHidden");
      await context.sync();

      const alreadyCollapsed = row7.rowHidden && row12.rowHidden;

      if (alreadyCollapsed) {
        ws.getRange("7:12").showGroupDetails(Excel.GroupOption.byRows);
        await context.sync();
        results.push({ taskId: 2, passed: true });
      } else {
        ws.getRange("7:12").hideGroupDetails(Excel.GroupOption.byRows);
        await context.sync();

        row7.load("rowHidden");
        row12.load("rowHidden");
        await context.sync();

        const passed = row7.rowHidden && row12.rowHidden;

        if (row7.rowHidden || row12.rowHidden) {
          ws.getRange("7:12").showGroupDetails(Excel.GroupOption.byRows);
          await context.sync();
        }

        results.push({ taskId: 2, passed });
      }
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Función VLOOKUP/BUSCARV en B8 con resultado correcto
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Encontrar un instructor");
      const celda = ws.getRange("B8");
      celda.load(["formulas", "values"]);
      await context.sync();

      const formula = (celda.formulas[0][0] || "").toString().toUpperCase();
      const tieneVlookup =
        formula.includes("VLOOKUP") || formula.includes("BUSCARV");
      const tieneIndex =
        formula.includes("INDEX") || formula.includes("INDICE");
      const tieneMatch =
        formula.includes("MATCH") || formula.includes("COINCIDIR");

      const tieneFormula = tieneVlookup || (tieneIndex && tieneMatch);
      const valor = String(celda.values[0][0]).trim();
      const valorCorrecto = valor === "Dan Webster";

      results.push({ taskId: 3, passed: tieneFormula && valorCorrecto });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  // Tareas 4 y 5: Opciones de corrección e idioma
  // No se pueden verificar vía Office.js — requieren "Marcar como completada"
  // No retornamos resultados para estas tareas para no sobreescribir marcado manual

  return results;
}
